import React, { useState, useCallback, useRef } from "react";

export function useToast() {
  const [toasts, setToasts] = useState([]);
  const timers = useRef({});

  const dismiss = useCallback((id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
    clearTimeout(timers.current[id]);
    delete timers.current[id];
  }, []);

  const showToast = useCallback((message, type = "success") => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev.slice(-4), { id, message, type }]);
    timers.current[id] = setTimeout(() => dismiss(id), 4500);
  }, [dismiss]);

  return { toasts, showToast, dismiss };
}

const TYPES = {
  success: { accent: "#22c55e", icon: "✓" },
  error:   { accent: "#ef4444", icon: "✗" },
  info:    { accent: "#3b82f6", icon: "i" },
  warning: { accent: "#f59e0b", icon: "!" },
};

export function ToastContainer({ toasts, onDismiss }) {
  if (!toasts.length) return null;
  return (
    <>
      <style>{`
        @keyframes toastIn { from { opacity:0; transform:translateX(40px); } to { opacity:1; transform:translateX(0); } }
      `}</style>
      <div style={{ position: "fixed", top: 20, right: 20, zIndex: 9999, display: "flex", flexDirection: "column", gap: 8, pointerEvents: "none" }}>
        {toasts.map(toast => {
          const c = TYPES[toast.type] || TYPES.success;
          return (
            <div key={toast.id} onClick={() => onDismiss(toast.id)}
              style={{
                pointerEvents: "auto",
                background: "#0f172a",
                borderLeft: `3px solid ${c.accent}`,
                borderRadius: 10,
                padding: "13px 16px",
                color: "white",
                display: "flex",
                alignItems: "center",
                gap: 10,
                minWidth: 260,
                maxWidth: 380,
                boxShadow: "0 8px 32px rgba(0,0,0,0.28), 0 2px 8px rgba(0,0,0,0.12)",
                animation: "toastIn 0.25s ease both",
                cursor: "pointer",
                fontSize: 13,
                fontFamily: "Inter, -apple-system, sans-serif",
              }}>
              <span style={{ width: 18, height: 18, background: c.accent, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 9, fontWeight: 900, color: "white", flexShrink: 0 }}>{c.icon}</span>
              <span style={{ flex: 1, lineHeight: 1.5, fontWeight: 500 }}>{toast.message}</span>
              <span style={{ opacity: 0.3, fontSize: 15 }}>×</span>
            </div>
          );
        })}
      </div>
    </>
  );
}
